import { useMutation } from '@tanstack/react-query';
import { groupBy, keys } from 'lodash';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys } from 'src/utils/queryKeys';

import { requestCCApi } from '../../../utils/axios-utils';
import { ProjectConfigTransaction } from './useUpdateProjectConfigs.interface';

export const useUpdateProjectConfigs = () => {
  return useMutation({
    mutationFn: updateProjectConfigs,
    onSuccess: (_, payload) => {
      keys(groupBy(payload, 'resource'))?.forEach((resource) => {
        queryClient.invalidateQueries(
          queryKeys[resource as keyof typeof queryKeys].invalidateAll(),
        );
        payload.forEach((item) => {
          queryClient.removeQueries(queryKeys.projectConfigs.details(item.id));
        });
      });
    },
  });
};

async function updateProjectConfigs(payload: ProjectConfigTransaction[]) {
  const response = await requestCCApi({
    url: `/transaction`,
    method: 'POST',
    data: {
      data: payload,
    },
  });

  return response.data;
}
